import React from 'react';
import { SmartDataTable } from '@src/components/SmartDataTable';
import { useTransactionsColumns } from './hooks/useTransactionsColumns';
import { useTransactionsFormFields } from './hooks/useTransactionsFormFields';

export const TransactionsPage = () => {
  const columns = useTransactionsColumns();
  const formFields = useTransactionsFormFields();

  return (
    <SmartDataTable
      api={{
        resource: 'medicine-transactions',
      }}
      title="Medicine Transactions"
      columns={columns}
      createForm={{
        fields: formFields as any,
        title: 'Create Transaction',
        submitText: 'Create Transaction',
      }}
      editForm={{
        fields: formFields as any,
        title: 'Edit Transaction',
        submitText: 'Save Changes',
      }}
      formDisplayMode="modal"
      showCreate={false}
      showEdit={false}
      showDelete={false}
      showView={false}
      isFilter={false}
      pageSize={10}
      showSizeChanger={true}
      showQuickJumper={false}
      showExport={false}
      showColumnVisibility={true}
      tableProps={{
        scroll: {
          x: 'max-content',
          y: 'calc(100vh - 300px)',
        },
      }}
      rowKey="id"
    />
  );
};
